export const quickEnroll = `quick-enroll`;
